import React from 'react'
import Retour from '../components/Retour'

function Bravo() {
  return (
    <div style={{textAlign: "center", fontSize: "60px", color: 'goldenrod'}}>
        <div>Bravo, tu as gagné le droit de me payer une binoche</div>
        <div>bisou...</div>
        <div><Retour /></div>
    </div>
  )
}

export default Bravo